import BaseUseCase from "../../../base_use_case.js";
import Routes from "../../../../admin/routes.js";
class ListCompaniesUseCase extends BaseUseCase {

  execute(params) {
    return this.httpClient({
      ...this.requestConfig(),
      method: "get",
      url: `/api/v1/admin/companies/companies`,
      params: params
    }).then((result) => {
      let { data, headers } = result; 
      let { companies } = data; 

      companies = companies.map((company) => {
        return {
          ...company,
          key: company.id,
          itemLink: Routes.company(company)
        }
      })
      data.list = companies;
      return {
        data: data,
        headers: headers
      }
    })
  }
}

const instance = new ListCompaniesUseCase();
export default instance;